module.exports = __webpack_public_path__ + "media/images/emoticons/smoking-9128116334eb3e08e5cb832d8d35de76.gif";